var path = '/app/pages/admin/admin.html';
var html = "<div class=container-fluid> <div class=row> <div class=\"col-2 bg-dark text-white\"> <div class=position-fixed style=height:100vh> <a ui-sref={{page.state}} ng-repeat=\"page in ctrl.pages\" ng-if=page.visible class=\"list-group-item list-group-item-action\">{{ page.title }}</a> </div> </div> <div class=col style=height:100vh> <ui-view></ui-view> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/admin.html
// module id = 580
// module chunks = 0